/* eslint-disable no-undef */
import Fetch from "./fetch";

// Below this distance the marker is animated along a straight line instead of
// asking OSRM for a road route - consecutive GPS pings are usually this close.
const SHORT_MOVE_METERS = 250;
const STRAIGHT_LINE_STEPS = 20;

const straightLine = (from, to) => {
  const start = new google.maps.LatLng(from.lat, from.lng);
  const end = new google.maps.LatLng(to.lat, to.lng);
  const points = [];

  for (let i = 1; i <= STRAIGHT_LINE_STEPS; ++i) {
    const point = google.maps.geometry.spherical.interpolate(
      start,
      end,
      i / STRAIGHT_LINE_STEPS
    );
    points.push({ lat: point.lat(), lng: point.lng() });
  }

  return points;
};

// Path ([{ lat, lng }]) for animating the bus marker from `from` to `to`.
// Returns [] when OSRM fails, so callers should jump the marker instead.
export const getMarkerPath = async (from, to) => {
  const distance = google.maps.geometry.spherical.computeDistanceBetween(
    new google.maps.LatLng(from.lat, from.lng),
    new google.maps.LatLng(to.lat, to.lng)
  );

  if (distance < SHORT_MOVE_METERS) {
    return straightLine(from, to);
  }

  const route = await Fetch("/bus-tracker/routeOSRM", {
    method: "post",
    data: {
      startPoint: { coordinates: from },
      endPoint: { coordinates: to }
    }
  });

  return route || [];
};

// Runs async jobs one at a time. A job queued while another is running replaces
// any earlier queued job with the same key, so a burst of socket pings during a
// slow OSRM call collapses into a single request for the latest ping.
export const createLatestRunner = () => {
  let busy = false;
  const pending = new Map();

  const run = async (key, job) => {
    if (busy) {
      pending.delete(key);
      pending.set(key, job);
      return;
    }

    busy = true;
    try {
      await job();
    } catch (err) {
      console.log(err);
    } finally {
      busy = false;
      const next = pending.entries().next().value;
      if (next) {
        pending.delete(next[0]);
        run(next[0], next[1]);
      }
    }
  };

  return run;
};
